var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
export class LanguageSelector extends Component {
    constructor(isDebugEnabled = false) {
        super('LanguageSelector', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            $('.language-selector').each((selector) => {
                new LanguageSelectorController(selector);
            });
            this.success();
        });
    }
    processLanguages() {
    }
}
class LanguageSelectorController {
    constructor(selector) {
        this.selector = selector;
        this.name = this.selector.attr('id');
        this.dataField = this.selector.find('input').eq(0);
        let languages = this.dataField.val().split(',');
        this.selector.find('input[type="checkbox"]').each((checkbox) => {
            if (languages.includes(checkbox.val()))
                checkbox.get(0).checked = true;
            checkbox.on('change', (event) => {
                this.updateLanguages();
            });
        });
        this.updateLanguages();
    }
    updateLanguages() {
        let languages = [];
        this.selector.find('input[type="checkbox"]').each((checkbox) => {
            if (checkbox.get(0).checked)
                languages.push(checkbox.get(0).value);
        });
        this.dataField.val(languages.join(','));
        if (languages.includes('99')) {
            $('[name="' + this.name.replace('_line', '_other') + '"]').parents('.form-control-row').removeClass('d-none');
        }
        else {
            $('[name="' + this.name.replace('_line', '_other') + '"]').parents('.form-control-row').addClass('d-none');
        }
    }
}
